import React, {ReactElement} from "react";
import {AddressType} from "@src/types/address.types";


interface AddressProps {
    address?: AddressType;
}

const Address: React.FC<AddressProps> = ({
    address
}): ReactElement => {

    if (!address) return;

    return (
        <>
            <div>
                {`${address.street} ${address.buildingNumber}` }
                {address.localNumber && ` lok. ${address.localNumber}` }
            </div>
            <div>{address.postCode} {address.city}</div>
        </>
    );
}

export default Address;